import { useState } from "react";
import { z } from "zod";
import { useMutation } from "@tanstack/react-query";
import { apiRequest } from "@shared/services/api/apiRequest";
import {
  contactSchemaBaseFields,
  withEmailConfirmationValidation,
} from "@shared/schemas/sharedSchemas";
import { ActionButtonsGroup } from "@shared/ui/ActionButtonsGroup";
import { useForm } from "@shared/features/form/useForm";
import { makeFormFields } from "@shared/utils/makeFormFields";
import { Form } from "@shared/features/form/Form";
import { Type } from "@shared/ui/Type";

export function MarketingContactForm() {
  const [isSuccess, setIsSuccess] = useState(false);

  const schema = withEmailConfirmationValidation(
    z.object({
      ...contactSchemaBaseFields,
    })
  );

  const fields = makeFormFields([
    "firstName",
    "lastName",
    "email",
    "confirmEmail",
    "message",
  ]);

  const submitForm = useMutation({
    mutationFn: async (data: z.infer<typeof schema>) => {
      try {
        return await apiRequest("/api/form-submission-proxy/", "POST", {
          first_name: data.firstName,
          last_name: data.lastName,
          ...data,
          form_type: "contact",
        });
      } catch (error) {
        throw error;
      }
    },
    onSuccess: (data, variables) => {
      setIsSuccess(true);
    },
  });

  const { form, handleSubmit } = useForm({
    schema,
    onSubmit: submitForm.mutateAsync,
  });

  const { isSubmitting, isLoading, isValid } = form.formState;

  if (isSuccess) {
    return (
      <div className="flex flex-col border border-brand-800 rounded-lg p-6 gap-2">
        <Type variant="h4">Thank you for your message!</Type>
        <Type variant="body2">We will get back to you shortly.</Type>
      </div>
    );
  }

  return (
    <>
      <Form
        fields={fields}
        form={form}
        className="max-w-sm"
        innerClassName="justify-center"
        errorContainerClassName="px-8"
      />
      <ActionButtonsGroup
        onPrimaryClick={handleSubmit}
        primaryButtonText={"Submit"}
        primaryButtonProps={{
          disabled: !isValid || isSubmitting || isLoading,
        }}
      />
    </>
  );
}

export default MarketingContactForm;
